import { baseQuery } from '../baseQuery';

type PostTaskNotePayload = {
  note: string;
  taskId: number;
  noteTypeId?: number;
};

export const postTaskNote = async ({ note, taskId, noteTypeId }: PostTaskNotePayload) => {
  const data = await baseQuery('task/notes', {
    type: 'POST',
    body: {
      task_ID: taskId,
      note,
      note_type_ID: noteTypeId,
    },
  });

  return data;
};
